// src/redux/slices/socialMediaSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchSocialMedia = createAsyncThunk("social/fetch", async () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const res = await axios.get(`${baseURL}/home/social-media`);
  return res.data.data;
});

const socialMediaSlice = createSlice({
  name: "socialMedia",
  initialState: {
    links: {},
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialMedia.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSocialMedia.fulfilled, (state, action) => {
        state.isLoading = false;
        state.links = action.payload;
      })
      .addCase(fetchSocialMedia.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default socialMediaSlice.reducer;
